import { Fragment } from 'react'
import {
  SeparatorDot,
  SeparatorLine
} from '../../../../../atoms/icons/special/index.js'
import {
  FilterOption,
  FilterTitle,
  OptionsContainer
} from '../styled-components.js'
import PropTypes from 'prop-types'

const ToolbarFilter = ({
  filters = [],
  selectedFilter = {},
  setSelectedFilter
}) => {
  if (!filters?.length) {
    return null
  }

  const handleSelectFilter = (option, filterIndex) => {
    setSelectedFilter?.({
      ...selectedFilter,
      [filterIndex]: option
    })
  }

  return (
    <>
      {filters.map((filter, filterIndex) => (
        <Fragment key={`${filter.title}-${filterIndex}`}>
          {filterIndex > 0 && <SeparatorLine />}

          <FilterTitle>{filter.title}:</FilterTitle>

          <OptionsContainer>
            {filter.options.map((option, index) => {
              const isSelected = selectedFilter[filterIndex]?.id === option.id

              return (
                <Fragment key={option.id}>
                  {index > 0 && <SeparatorDot />}
                  <FilterOption
                    onClick={() => handleSelectFilter(option, filterIndex)}
                    data-selected={isSelected}
                  >
                    {option.value}
                  </FilterOption>
                </Fragment>
              )
            })}
          </OptionsContainer>
        </Fragment>
      ))}
    </>
  )
}

ToolbarFilter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
          value: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ),
  selectedFilter: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  setSelectedFilter: PropTypes.func
}

export default ToolbarFilter
